<!-- <div style="height: 20px; border: 1px solid #000000;"> -->
<div class="time-sheet">
  <div class="d-flex no-wrap">
    @for (entry of numberLineWidths.keys(); track entry.id) {
    <app-time-sheet-entry-item
      [entry]="entry"
      [width]="numberLineWidths.get(entry) || 0"
      [categoryColor]="getCategoryColor(entry)"
      [project]="getProject(entry)"
      (onEntryClick)="openEntryLogItem($event)"
    ></app-time-sheet-entry-item>
    }
  </div>
  <div class="d-flex entry-log align-items-start number-line">
    @for (i of createNumberLineArray(); track i) {
    <div
      class="number-line-item"
      [ngStyle]="{
        width: sizeModifier + 'px',
        height: getNumberLineHeight(i)
      }"
    >
      {{ getNumberLineValue(i) }}
    </div>
    }
  </div>
</div>
